module.exports = __webpack_public_path__ + "img/reports.5a1a2106.png";